import { render, staticRenderFns } from "./DonateHe.vue?vue&type=template&id=53df2ba0&"
import script from "./DonateHe.vue?vue&type=script&lang=js&"
export * from "./DonateHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports